import styled, { css } from 'styled-components';

export const ProgressWrapper = styled.div`
    display: flex;
    align-self: flex-start;
    width: 100%;
    padding: 1rem 0;
    flex-direction: column;
`;

export const ProgressBar = styled.div`
    display: flex;
    width: 100%;
    padding: .25rem 0;
`;

export const ProgressBarLabel = styled.div`
    width: 5rem;
    padding: 0 1rem;
    font-weight: bold;
`;

export const ProgressBarWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    text-align: center;
`;

export const ProgressBarOuter = styled.div`
    position: relative;
    width: 100%;
    height: 0.5rem;
    background-color: #ddd;
    border-radius: 10rem;
    overflow: hidden;
    margin-bottom: 0.3rem;
`;


export const ProgressBarInner = styled.div<{ progress? }>`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
    background-color: ${props => props.progress >= 100 ? '#64b450' : '#0985c7'};
    width: ${props => props.progress}%;
`;
